export const DONE = "Done";
export const FAILED = "Failed";
export const REQUESTED = "Requested";
export const NONE = "None";
export const IN_PROGRESS = "InProgress";
